/** Existing production GA4 destination, verified in GTM-TRHGQ4W. */
const MEASUREMENT_ID = "G-HGYMWGF5T5";

type EnquiryEvent = "lead_submitted" | "whatsapp_clicked";

export function trackEnquiry(event: EnquiryEvent, form?: string) {
  if (typeof window === "undefined") return;
  try {
    const params = {
      send_to: MEASUREMENT_ID,
      page_path: window.location.pathname,
      // Deliberately exclude URL queries, message text and contact details.
      ...(form ? { form } : {}),
      transport_type: "beacon",
    };
    if (window.gtag) window.gtag("event", event, params);
    else {
      window.dataLayer = window.dataLayer || [];
      // Google's command queue expects an Arguments object, not a GTM custom event.
      // eslint-disable-next-line prefer-rest-params -- gtag uses an Arguments command queue.
      function enqueue(..._args: unknown[]) { window.dataLayer!.push(arguments); }
      enqueue("event", event, params);
    }
  } catch { /* Analytics must never interrupt an enquiry. */ }
}

/** One delegated listener also covers CMS links and links added after navigation. */
export function installWhatsAppTracking() {
  const onClick = (event: MouseEvent) => {
    if (event.type === "auxclick" && event.button !== 1) return;
    if (event.type === "click" && event.button !== 0) return;
    const target = event.target instanceof Element ? event.target : null;
    const link = target?.closest("a[href]");
    if (!link) return;
    try {
      const url = new URL(link.getAttribute("href")!, window.location.href);
      if ((url.protocol === "https:" || url.protocol === "http:") &&
          (url.hostname === "wa.me" || url.hostname === "api.whatsapp.com")) {
        trackEnquiry("whatsapp_clicked");
      }
    } catch { /* Ignore malformed links. */ }
  };
  document.addEventListener("click", onClick, true);
  document.addEventListener("auxclick", onClick, true);
  return () => {
    document.removeEventListener("click", onClick, true);
    document.removeEventListener("auxclick", onClick, true);
  };
}
